<template>
  <v-container fluid>
    <!-- <p>{{ form  }}</p> -->
    <!-- <p>{{ component  }}</p> -->
    <v-row justify="center">
      <v-col class="content_inner">
        <div class="margin-bottom-2x">
          <span @click="back" class="curson-pointer font-size-14 text-body-2">
            <v-icon left style="margin-right:0">mdi-chevron-left</v-icon>返回
          </span>
        </div>
        <v-card class="form-card card-padding">
          <!-- <p> {{comCode}}  {{Boolean(comCode)}}</p> -->
          <h2 class="card-title">{{comCode ? '编辑组件' : '添加组件'}}</h2>
          <v-tabs v-model="tabValue">
            <v-tab key="base">基础信息</v-tab>
            <v-tab v-if="(comCode && component && component.comType ===1) || isAppType" key="apps">绑定应用</v-tab>
          </v-tabs>
          <v-card-text>
            <!-- <p>{{form}}</p> -->
            <v-form v-show="tabValue === 0" v-model="valid"  ref="form">
              <ul  class="form-ul label-width-9">
                <li class="required">
                  <span class="label">组件Code：</span>
                  <div class="v-input-box">
                    <v-text-field ref="appCode" placeholder="请输入" v-model="form.comCode" solo required :rules="rules.appCode" :disabled="Boolean(comCode)"></v-text-field>
                  </div>
                </li>
                <li class="required">
                  <span class="label">名称：</span>
                  <div class="v-input-box">
                    <v-text-field ref="appName" placeholder="请输入" v-model="form.comName" solo required :rules="rules.appName" :error-messages="errorMessages"></v-text-field>
                  </div>
                </li>
                <li class="required">
                  <span class="label">英文名称：</span>
                  <div class="v-input-box">
                    <v-text-field ref="appNameEn" placeholder="请输入" v-model="form.nameEn" solo required :rules="rules.appNameEn" :error-messages="errorMessages"></v-text-field>
                  </div>
                </li>

                <li>
                  <span class="label">组件类型：</span>
                  <div class="v-input-box">
                    <v-radio-group v-model="form.comType" mandatory row>
                      <v-radio v-for="item in componentTypeList" :key="item.id" :label="item.name" :value="item.id" ></v-radio>
                    </v-radio-group>
                  </div>
                </li>
                <li>
                  <span class="label">用户类型：</span>
                  <div class="v-input-box">
                    <div v-for="(item, key) in userTypeList" :key="key" class="chieck-box-inline">
                      <v-checkbox v-model="form.userTypeArr" :label="item.name" :value="item.label" :rules="rules.userTypeArr" ></v-checkbox>
                    </div>
                  </div>
                </li>
                <li>
                  <span class="label">平台类型：</span>
                  <div class="v-input-box">
                    <v-radio-group v-model="form.platType" mandatory row>
                      <v-radio v-for="item in platTypeList" :key="item.code" :label="item.name" :value="item.code" ></v-radio>
                    </v-radio-group>
                  </div>
                </li>
                <template v-if="form.comType === 1">
                  <li>
                    <span class="label">应用图标目录：</span>
                    <div class="v-input-box">
                      <v-radio-group v-model="form.appIconStyle" mandatory row>
                        <v-radio v-for="item in iconDirectoryList[form.platType]" :key="item.id" :label="item.name" :value="item.name" ></v-radio>
                      </v-radio-group>
                    </div>
                  </li>
                  <li>
                    <span class="label">使用默认主题图标：</span>
                    <div class="v-input-box">
                      <v-switch
                        v-model="form.defaultTheme"
                        :label="form.defaultTheme ? '优先使用默认主题图标' : '优先使用自定义主题图标'"
                      ></v-switch>
                    </div>
                  </li>
                  <li style="height:80px;padding: 25px 25px 0 0">
                    <span class="label">显示应用最大数量：</span>
                    <div class="v-input-box" style="padding-top: 10px" >
                      <v-slider
                        v-model="form.extraConfig.maxNumber"
                        max="20"
                        min="1"
                        thumb-label="always"
                      ></v-slider>
                      <!-- <v-text-field ref="appsCount" placeholder="请输入" v-model="form.appsCount" solo required type="number"></v-text-field> -->
                    </div>
                  </li>
                  <li>
                    <span class="label">显示全部应用：</span>
                    <div class="v-input-box">
                      <v-switch
                        v-model="form.extraConfig.isAllApps"
                        :label="form.extraConfig.isAllApps ? '显示' : '不显示'"
                      ></v-switch>
                    </div>
                  </li>
                </template>
                <template v-if="form.comType === 2">
                  <li style="height:80px;padding: 25px 25px 0 0">
                    <span class="label">显示广告最大数量：</span>
                      <!-- {{form.extraConfig}} -->
                    <div class="v-input-box" style="padding-top: 10px" >
                      <v-slider
                        v-model="form.extraConfig.maxNumber"
                        max="10"
                        min="1"
                        thumb-label="always"
                      ></v-slider>
                    </div>
                  </li>
                </template>
                <!-- <p>comCode:{{comCode}} , fileFlag:{{fileFlag}}  , form.comIcon:{{form.comIcon}}  component:{{component.comIcon}}</p> -->
                <!-- <p>imgFile:{{imgFile.url}}</p> -->
                <li class="li-file required">
                  <span class="label">组件图示：</span>
                  <div class="v-input-box">
                    <div class="text-right" v-if="comCode && form.comIconUrl">
                      <v-btn
                        color="blue"
                        text
                        @click="fileEdit"
                      >
                        {{fileFlag ? '取消修改' : '修改'}}
                      </v-btn>
                    </div>
                    <template v-if="comCode">
                      <template v-if="form.comIconUrl && !fileFlag">
                        <img class="component-img"  :src="form.comIconUrl + '?v=' + timestamp" alt="img"  width="100%">
                      </template>
                      <template v-else>
                        <img v-if="imgFile.url" :src="imgFile.url" alt="img">
                        <v-file-input accept="image/*"
                          label="File input"
                          prepend-icon="mdi-file-image"
                          @change="changeFile"
                        ></v-file-input>
                      </template>
                    </template>
                    <template v-else>
                      <img v-if="imgFile.url" :src="imgFile.url" alt="img">
                      <v-file-input accept="image/*"
                        label="File input"
                        prepend-icon="mdi-file-image"
                        @change="changeFile"
                      ></v-file-input>
                    </template>
                  </div>
                </li>
                <li>
                  <span class="label">说明：</span>
                  <div class="v-input-box">
                    <v-textarea rows="2" placeholder="请输入" v-model="form.description" solo></v-textarea>
                  </div>
                </li>
              </ul>
              <div class="text-center">
                <v-btn large class="ma-2 white--text btn-large "  color="blue" style="margin: 0 auto!important;" @click="submit">确定</v-btn>
              </div>
            </v-form>

            <add-app-list v-if="tabValue === 1" :data="component"></add-app-list>
          </v-card-text>

        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h6">
          组件添加成功
        </v-card-title>
        <v-card-text>是否进行绑定应用？</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="orange darken-2"
            text
            @click="toIndex"
          >
            不，下次绑定
          </v-btn>
          <v-btn
            color="green darken-2"
            text
            @click="toBindApps"
          >
            立即绑定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'
import addAppList from './module/addAppList.vue'
const request = buildAxios()
export default {
  components: {
    addAppList
  },
  data () {
    return {
      comCode: this.$route.query.comCode,
      component: null,
      tabValue: this.$route.query.tab ? parseInt(this.$route.query.tab) : 0,
      errorMessages: '',
      imgFile: {
        base64: null,
        url: ''
      },
      valid: true,
      rules: {
        comCode: [
          v => !!v || '请填写组件Code',
          v => v.length <= 20 || '组件Code 不能超过20个字符长度'
        ],
        comName: [
          v => !!v || '请填写应用名称'
        ],
        comNameEn: [
          v => !!v || '请填写应用英文名称'
        ]
      },
      form: {
        appIconStyle: null,
        comCode: '',
        comIcon: null,
        comName: '',
        comType: null,
        defaultTheme: false,
        description: '',
        extraConfig: {
          isAllApps: false,
          maxNumber: 3
        },
        nameEn: '',
        platType: null,
        // userType: null
        userTypeArr: []
      },
      info: {},
      fileFlag: false, // 编辑文件
      dialog: false,
      isAppType: false,
      timestamp: new Date().getTime()
      // isEditorShow: false,
      // jsonDialog: false,
      // platTypeList: []
      // isAllApps: false,
      // maxNumber: 3
    }
  },
  computed: {
    ...mapState(['platTypeList', 'userTypeList', 'componentTypeList', 'iconDirectoryList'])
    // getDefaultContent () {
    //   return cloneDeep(this.defaultContent) // 【注意】深度拷贝 defaultContent ，否则会报错
    // }
  },
  watch: {
    //  handler () {
    //     this.getList()
    //   },
    //   deep: true
    // form: {
    //   handler (val) {
    //     if (val.comType === 1 && !val.extraConfig) {
    //       console.log('sss', val)
    //       this.$set(this.form.extraConfig, 'isAllApps', false)
    //       this.$set(this.form.extraConfig, 'maxNumber', 3)
    //     }
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },
  beforeDestroy () {
    // const editor = getEditor(this.editorId)
    // if (editor == null) return
    // editor.destroy()
    // removeEditor(this.editorId)
  },
  created () {
    if (this.comCode) {
      this.form = this.component = JSON.parse(sessionStorage.getItem('componentDetail'))
      if (this.component.comType === 2) {
        this.component.extraConfig = {}
        this.$set(this.component.extraConfig, 'maxNumber', 3)
        this.$set(this.form.extraConfig, 'maxNumber', 3)
      }
      const arr = []
      console.log('component', this.form, this.component)
      if (this.component.userType === 'common') {
        this.userTypeList.forEach((element) => {
          arr.push(element.label)
        })
      } else {
        arr.push(this.component.userType)
      }
      // this.$delete(this.component.extraConfig, 'platType')
      this.$set(this.form, 'userTypeArr', arr)
    }
  },
  mounted () {
  },
  methods: {
    back () {
      this.$router.back(-1)
    },
    toIndex () {
      // this.$emit('alert', {
      //   msg: '组件添加成功',
      //   type: 'success'
      // })
      this.dialog = false
      this.back()
      // this.$router.push({ name: 'componentList' })
    },
    toBindApps () {
      this.dialog = false
      // if (this.form.comType === 1) {
      this.isAppType = true
      this.tabValue = 1
      // }
    },
    // upload
    changeFile (file) {
      console.log('changeFile', file)
      if (file) {
        // this.form.file = file
        const fileReader = new FileReader()
        fileReader.readAsDataURL(file)
        fileReader.onload = (e) => {
          console.log(e.target)
          this.imgFile.base64 = e.target.result
          this.uploadFile(file)
        }
        this.timestamp = new Date().getTime()
      } else {
        this.imgFile.base64 = null
        this.imgFile.url = ''
      }
    },
    uploadFile (file) {
      const formData = new FormData()
      if (!this.form.comCode) {
        this.$emit('alert', {
          msg: '请先输入组件code！',
          type: 'error'
        })
        return false
      }
      formData.append('iconName', this.form.comCode)
      formData.append('iconType', 'component')
      formData.append('file', file)
      // /cloud-api/baseIcon/addIcon
      request.defaults.headers['content-type'] = 'multipart/form-data'
      request.post('baseIcon/addIcon', formData).then(res => {
        console.log(res)
        this.imgFile.url = res.data.data.url
        this.form.comIcon = this.form.comCode
        // this.form.comIcon = this.form.comCode
        console.log('uploadFile', res.data.data.url, this.imgFile)
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    },
    // submit
    submit () {
      console.log('submit !!!', this.form)
      if (!this.comCode && (!this.$refs.form.validate() || !this.uploadFile)) { // 添加
        this.$emit('alert', {
          msg: '表单填写有误！',
          type: 'error'
        })
        return false
      }
      if (this.comCode && !this.$refs.form.validate()) { // 编辑
        this.$emit('alert', {
          msg: '表单填写有误！',
          type: 'error'
        })
        return false
      }
      if (this.comCode && this.fileFlag) {
        this.$delete(this.form, 'comIcon')
      }
      if (this.form.comType !== 1 && this.form.comType !== 2) {
        this.$delete(this.form, 'extraConfig')
        // console.log('comType', this.form.comType)
      }
      // console.log(this.form)
      if (this.form.userTypeArr.length > 1) {
        this.$set(this.form, 'userType', 'common')
      } else {
        this.$set(this.form, 'userType', this.form.userTypeArr[0])
      }
      // if (this.form.userTypeArr.length > 1) {
      //   this.$set(this.form, 'userType', 'common')
      // } else {
      //   this.$set(this.form, 'userType', this.form.userTypeArr[0])
      // }
      const params = JSON.parse(JSON.stringify(this.form))
      this.$delete(params, 'comIconUrl')
      this.$delete(params, 'userTypeArr')
      if (this.comCode) { // 编辑
        // console.log('edit', this.form)
        this.editSubmit(params)
      } else { // 添加
        this.addSubmit(params)
        // console.log(this.form)
      }
    },
    // add
    addSubmit (data) {
      request.defaults.headers['content-type'] = 'application/json;charset=UTF-8'
      request.post('baseComponent/add', data).then(res => {
        if (data.comType === 1) {
          this.dialog = true
        } else {
          this.$emit('alert', {
            msg: '组件添加成功',
            type: 'success'
          })
          this.$router.push({ name: 'componentList' })
        }
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    },
    fileEdit () {
      this.fileFlag = !this.fileFlag
      if (!this.fileFlag) {
        this.imgFile = {
          base64: null,
          url: null
        }
      }
    },
    editSubmit (data) {
      request.defaults.headers['content-type'] = 'application/json;charset=UTF-8'
      request.post('baseComponent/update', data).then(res => {
        this.$router.push({ name: 'componentList' })
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    }
  }
}
</script>
<style>
.v-slider__thumb {
  cursor: pointer;
}
</style>
